import React, { useState } from 'react';
import { getPopularMovies, getGenreNameFromId } from '../services/movieService';
import { TMDB_IMAGE_BASE_URL } from '../config';
import { useData } from '../context/DataContext';
import ItemList from './shared/ItemList';
import FilterSection from './shared/FilterSection';
import './MovieList.css';

function MovieList() {
  const { preloadedMovies } = useData();
  
  // Initialize filters from localStorage or use defaults
  const [activeFilters, setActiveFilters] = useState(() => {
    const savedFilters = localStorage.getItem('movieActiveFilters');
    return savedFilters ? JSON.parse(savedFilters) : {
      year: '',
      genre: ''
    };
  });

  // Handle filter changes
  const handleFilterChange = (filterType, value) => {
    setActiveFilters(prev => ({
      ...prev,
      [filterType]: prev[filterType] === value ? '' : value
    }));
  };

  // Define filter groups for movies
  const movieFilterGroups = [
    {
      id: 'year',
      title: 'Time Period',
      options: [
        { label: 'All Time', value: '', className: 'all-time' },
        { label: `${new Date().getFullYear()}`, value: 'currentYear', className: 'year' },
        { label: `${new Date().getFullYear() - 1}`, value: 'currentYearMinus1', className: 'year' },
        { label: `${new Date().getFullYear() - 2}`, value: 'currentYearMinus2', className: 'year' },
        { label: `${Math.floor((new Date().getFullYear() - 2) / 10) * 10}s`, value: 'lastDecade', className: 'decade' },
        { label: `${Math.floor((new Date().getFullYear() - 2) / 10) * 10 - 10}s`, value: 'lastDecadeMinus10', className: 'decade' },
        { label: `${Math.floor((new Date().getFullYear() - 2) / 10) * 10 - 20}s`, value: 'lastDecadeMinus20', className: 'decade' },
        { label: 'Older Movies', value: 'older', className: 'all-time' }
      ]
    },
    {
      id: 'genre',
      title: 'Genre',
      options: [
        { label: 'All Genres', value: '', className: 'all-time' },
        { label: 'Action', value: 'action', className: 'year' },
        { label: 'Drama', value: 'drama', className: 'year' },
        { label: 'Comedy', value: 'comedy', className: 'year' },
        { label: 'Sci-Fi', value: 'scifi', className: 'year' },
        { label: 'Horror', value: 'horror', className: 'year' },
        { label: 'Romance', value: 'romance', className: 'year' },
        { label: 'Documentary', value: 'documentary', className: 'year' }
      ]
    }
  ];

  // Render the filter section
  const renderFilterSection = () => {
    return (
      <FilterSection 
        activeFilters={activeFilters}
        onFilterChange={handleFilterChange}
        filterGroups={movieFilterGroups}
      />
    );
  };

  // Format movie for display
  const formatMovieForDisplay = (movie) => {
    return {
      id: movie.id,
      imageComponent: movie.poster_path && (
        <img
          src={`${TMDB_IMAGE_BASE_URL}${movie.poster_path}`}
          alt={movie.title}
          className="movie-poster"
        />
      ),
      contentComponent: (
        <>
          <h2>{movie.title}</h2>
          <div className="movie-genre">
            {movie.genre_ids && movie.genre_ids.length > 0 
              ? movie.genre_ids.map((genreId, index) => (
                  <span key={genreId}>
                    {getGenreNameFromId(genreId)}
                    {index < movie.genre_ids.length - 1 ? ', ' : ''}
                  </span>
                ))
              : 'Unknown Genre'
            }
          </div>
          <div className="movie-director">
            <span>Director: {movie.director || 'Unknown'}</span>
            <span>{movie.release_date?.split('-')[0] || 'Unknown Year'}</span>
          </div>
          <div className="movie-card-footer">
            <div className="movie-rating">
              {movie.vote_average?.toFixed(1)}/10
            </div>
          </div>
        </>
      )
    };
  };

  return (
    <ItemList
      type="movie"
      fetchItems={getPopularMovies}
      preloadedItems={preloadedMovies}
      activeFilters={activeFilters}
      renderFilterSection={renderFilterSection}
      title="Top Rated Movies"
      formatItemForDisplay={formatMovieForDisplay}
    />
  );
}

export default MovieList; 